import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAll(data) {
        let params = "";
        if (data) {
            Object.keys(data).forEach(key => {
                params += `${key}=${data[key]}&`;
            });
        }
        return api.get(`/api/v1/item-admin?${params}`);
    },
    getAllList() {
        return api.post(`/api/v1/item/list`);
    },
    getById(id) {
        return api.get(`/api/v1/item/${id}`);
    },
    update(id, data) {
        return api.post(`/api/v1/item/${id}`, data);
    },
    create(data) {
        return api.post(`/api/v1/item`, data);
    },
    delete(id) {
        return api.delete(`/api/v1/item/${id}`);
    },
    active(id) {
        return api.post(`/api/v1/item/active/${id}`);
    },
}